export default __webpack_public_path__ + "static/optical-adjustment-dont-f8b784e2c763844dd566c6422b24403ffe1f8299611a8bc88121841d2a0b0f69.png";